module.exports = __webpack_public_path__ + "img/Quadfishathon-Logo.b0882f43.png";